import type { DisplayTextProps } from './display.types'

import { omitThemingProps, styled, useStyleConfig, vui } from '../core'
import { cs } from '../utils'

export const DisplayBase = styled.pBox``

export const Display = vui<'p', DisplayTextProps>((props, ref) => {
  const { children, className, ...rest } = omitThemingProps(props)
  const styles = useStyleConfig('Display', props)

  return (
    <DisplayBase className={cs('vui-display', className)} ref={ref} {...styles} {...rest}>
      {children}
    </DisplayBase>
  )
})

Display.displayName = 'Display'
export default Display
